import styled from "@emotion/styled";
import { NEGATIVE_FEEDBACK_COMMENTS, POSITIVE_FEEDBACK_COMMENTS } from "../../../constants/feedback-comments";
import { colors, fonts, radius, spacing } from "../../design-tokens";

const CommentGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${spacing.sm}px;
  width: 100%;
`;

const CommentButton = styled.button<{ isActive?: boolean }>`
  padding: ${spacing.sm}px ${spacing.sm}px;
  border: 1px solid ${colors.neutralGrey};
  background: ${props => props.isActive
    ? colors.surface
    : "transparent"};
  color: ${props => props.isActive
    ? colors.text
    : colors.text};
  font-family: inherit;
  cursor: pointer;
  transition: all 200ms ease-in-out;
  ${fonts.bodyFont}
  font-size: 14px;
  font-weight: 400;
  line-height: 1.2;
  text-align: center;
  border-radius: ${radius.sm}px;
  white-space: nowrap;
  width: 100%;
  min-width: 0;

  &:hover:not(:disabled) {
    color: ${colors.text};
    background: ${props => props.isActive
      ? colors.surfaceHover
      : colors.surface};
    border-color: ${colors.textSecondary};
  }

  &:active:not(:disabled) {
    background: ${colors.surfaceHover};
    transform: scale(0.98);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

type CommentOptionsProps = {
  readonly selectedComment: string | null;
  readonly isSubmitting: boolean;
  readonly isPositive: boolean;
  readonly onCommentSelect: (comment: string) => void;
};

export function CommentOptions({ selectedComment, isSubmitting, isPositive, onCommentSelect }: CommentOptionsProps) {
  const comments = isPositive ? POSITIVE_FEEDBACK_COMMENTS : NEGATIVE_FEEDBACK_COMMENTS;

  return (
    <CommentGrid>
      {comments.map(comment => (
        <CommentButton
          key={comment}
          isActive={selectedComment === comment}
          onClick={() => onCommentSelect(comment)}
          disabled={isSubmitting}
          aria-label={`Select feedback reason: ${comment}`}
        >
          {comment}
        </CommentButton>
      ))}
    </CommentGrid>
  );
}
